"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  "595b29c56bce953ca7b20909": {
    primary: "#E52D27",
    primaryLighterBy10: "#FF4741",
    primaryLighterBy20: "#FF605A",
    primaryLighterBy30: "#FF7A74",
    primaryLighterBy40: "#FF938D",
    primaryLighterBy50: "#FFACA6",
    primaryDarkerBy10: "#CC140E",
    primaryDarkerBy20: "#B20000",
    primaryDarkerBy30: "#990000",
    primaryDarkerBy40: "#7F0000",
    primaryDarkerBy50: "#660000",
    black: "#000",
    black10: "#1A1A1A",
    blackLighterBy20: "#333333",
    blackLighterBy30: "#4D4D4D",
    blackLighterBy40: "#666666",
    blackLighterBy50: "#7F7F7F",
    white: "#FFF",
    whiteDardkerBy5: "#F2F2F2",
    whiteDardkerBy10: "#E6E6E6",
    whiteDardkerBy15: "#D9D9D9",
    whiteDardkerBy20: "#CCCCCC",
    whiteDardkerBy25: "#BFBFBF",
    secondary: "#B31217",
    tertiary: "#E8171E",
    redlabel: "#E11F26",
    disabled: "#BBB",
    gold: "#FAAD3D",
    goldLighterBy10: "#FFC757",
    goldLighterBy20: "#FFE070",
    goldLighterBy30: "#FFFA8A",
    goldLighterBy40: "#FFFFA3",
    goldLighterBy50: "#FFFFBC",
    darkModerateBlue: "#3F5F8B",
    redorange: "#f90406",
    yellow: "#f9d74f",
    yellowDisabled: "#fcedab" //logo: "/images/ace-logo.png"

  },
  "default": {
    primaryDark: "#C2171D",
    primary: "#ef0a0a",
    primary75P: "#4848E5",
    primary50P: "#ecb9bb",
    primary25P: "#C2C2F6",
    primary10P: "#E6E6FB",
    secondary: "#49B5DD",
    secondaryPomegranate: "#F4364C",
    secondaryPomegranate75P: "#F76979",
    secondaryPomegranate50P: "#F99AA5",
    secondaryPomegranate25P: "#FCCDD2",
    secondaryPomegranate10P: "#FDEAED",
    secondaryBanana: "#FFC600",
    secondaryBanana75P: "#FFD540",
    secondaryBanana50P: "#FFE27F",
    secondaryBanana25P: "#FFF1BF",
    secondaryBanana10P: "#FFF9E5",
    secondarySky: "#00B5E2",
    secondarySky75P: "#40CBEA",
    secondarySky50P: "#F85E5E",
    secondarySky25P: "#fddede",
    secondarySky10P: "#feeeee",
    primaryTextColor: "#FFF",
    primaryForeground: "#FFF",
    grey: "#BCBCBC",
    grey75P: "#CDCDCD",
    grey50P: "#DDD",
    grey25P: "#EEE",
    greyDarker: "#9EA0A5",
    greyDarker75P: "#B7B8BC",
    greyDarker50P: "#CECFD2",
    greyDarker25P: "#E7E7E8",
    greyMid: "#7C878E",
    greyMid75P: "#9DA5AB",
    greyMid50P: "#BDC3C6",
    greyMid25P: "#DEE1E3",
    black80P: "#333",
    black10P: "#E5E5E5",
    lightBlue: "#CCEEFE",
    disabledPrimary: "#888",
    disabledSecondary: "#CCC",
    error: "#E04852",
    cancelBtn: "#E04852",
    confirmBtn: "#C2171D",
    //normally this is green
    neutralBtn: "#C2171D" //logo: "/images/shopsm-logo.png"

  }
};
exports["default"] = _default;
module.exports = exports["default"];